import { PaymentMethodType, SavedPaymentMethod } from '../../types'
import { OrderMerchant } from '../types'

export enum AgreementStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
  PENDING_RENEWAL = 'PENDING_RENEWAL',
  PENDING_RENEWAL_EXPIRED = 'PENDING_RENEWAL_EXPIRED',
}

export interface Agreement {
  id: number
  createdAt: number
  merchant: OrderMerchant
  status: AgreementStatus
  paymentMethod: (SavedPaymentMethod & { type: PaymentMethodType.CREDIT_CARD }) | null
  usingPreferredPaymentMethod?: boolean
}

export interface BillingAgreementsResponse {
  totalResults: number
  offset: number
  limit: number
  results: Agreement[]
}

export interface BillingAgreementResponse extends Agreement {}
